module.exports = __webpack_public_path__ + "img/yuyuejisao.204bbd1d.png";